import type {
  TableFiveData,
  TableFourData,
  TableOneData,
  TableSixData,
  TableThreeData,
  TableTwoData,
} from "./type";

export const defaultTableOne: TableOneData = {
  id: null,
  startDate: undefined,
  endDate: undefined,
  note: "",
};

export const defaultTableTwo: TableTwoData = {
  id: null,
  jobPosition: "",
  startDate: undefined,
  endDate: undefined,
};

export const defaultTableThree: TableThreeData = {
  id: null,
  firstName: "",
  lastName: "",
};

export const defaultTableFour: TableFourData = {
  id: null,
  name: "",
  place: "",
  phone: "",
};

export const defaultTableFive: TableFiveData = {
  id: null,
  name: "",
  startDate: undefined,
  endDate: undefined,
};

export const defaultTableSix: TableSixData = {
  id: null,
  position: "",
  name: "",
  startDate: undefined,
  endDate: undefined,
};
